import { Typography } from "@suraasa/placebo-ui"
import { Masterclass } from "api/resources/masterclasses/types"
import { MASTERCLASS_ONBOARDING_TARGETS } from "features/Home/SuraasaPlusNewYearOnboarding/MasterclassOnboarding/types"
import { useRef } from "react"
import { Link } from "react-router-dom"
import routes, { routeBuilder } from "routes"
import { formatDate } from "utils/helpers"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"

import DEFAULT_MASTERCLASS_IMAGE from "../../../assets/Placeholder/default-masterclass-thumbnail.svg"
import { getMasterclassStatus } from "../UpcomingMasterclass/helpers"

type MasterclassCardProps = {
  masterclass: Masterclass
}

const MasterclassCard = ({ masterclass }: MasterclassCardProps) => {
  const ref = useRef<HTMLDivElement | null>(null)

  const status = getMasterclassStatus(masterclass)
  const isUpcoming = status === "upcoming"
  if (!masterclass) return null

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      to={routeBuilder(routes.viewMasterclass, { slug: masterclass.slug })}
      data-tour={
        !isUpcoming ? MASTERCLASS_ONBOARDING_TARGETS.previous : undefined
      }
      onClick={() => {
        trackingService.trackEvent(
          TrackingEvents.masterclassCardClicked,
          {
            masterclass_id: masterclass.id,
            masterclass_slug: masterclass.slug,
            masterclass_title: masterclass.title,
            status: status,
          },
          { services: ["PostHog"] }
        )
      }}
    >
      <div
        className="flex h-full cursor-pointer flex-col justify-between rounded-lg border border-onSurface-200"
        ref={ref}
      >
        <img
          alt="thumbnail"
          className="aspect-[16/9] w-full rounded-t-lg object-cover"
          src={masterclass.thumbnail ?? DEFAULT_MASTERCLASS_IMAGE}
          onError={e => (e.currentTarget.src = DEFAULT_MASTERCLASS_IMAGE)}
        />
        <div className="p-2">
          <Typography
            className="first-letter-capitalize mb-0.5 text-onSurface-800"
            variant="title4"
          >
            {masterclass.title}
          </Typography>
          <Typography
            className="!text-[12px] text-onSurface-600"
            variant="smallBody"
          >
            {formatDate(masterclass.startTime, "dd MMM yyyy")}
          </Typography>
        </div>
      </div>
    </Link>
  )
}

export default MasterclassCard
